"use client";
import { jsx, Fragment } from "react/jsx-runtime";
import { logos } from "./logos.js";
import classNames from "classnames";
import { svgVariant, logoVariant } from "./Logo.css.js";
const logoTitles = {
  bilhold: "Bilhold",
  mollerbil: "Møller Bil",
  skoda: "Skoda",
  gumpen: "Gumpen",
  vw: "Volkswagen",
  vwnytte: "Volkswagen Nytte",
  dahles: "Dahles Auto",
  autoria: "Autoria",
  audi: "Audi",
  cupra: "Cupra",
  berge: "Berge & Co",
  fremme: "fremme",
  sulland: "Sulland",
  slatlem: "Slatlem",
  albjerk: "Albjerk",
  kirkenes: "Kirkenes",
  alta: "Alta",
  svebjorn: "Svebjørn",
  mobile: "Mobile"
};
const Logo = ({ size = "l", role = "img", focusable = false, type, brand, className, ...rest }) => {
  const logo = logos.find((x) => x.key === brand);
  if (!logo) {
    return jsx(Fragment, {});
  }
  const Component = logo[type];
  return jsx("span", { className: classNames(className, logoVariant[size]), children: jsx(Component, { title: logoTitles[brand], role, focusable, className: svgVariant[size], ...rest }) });
};
export {
  Logo
};
